import { smsCampaignFeatureGuard, smsCampaignBlockPageGuard } from '@/pages/smsCampaigns/util/routerGuards';

const SMSCampaignsMain = () => import(/* webpackChunkName: "sms" */ '@/pages/smsCampaigns/main');
const CreateSMSCampaign = () => import(/* webpackChunkName: "sms" */ '@/pages/smsCampaigns/createCampaign');
const SMSCampaignsFeatureBlock = () => import(/* webpackChunkName: "sms" */ '@/pages/smsCampaigns/featureBlock');

export default [
  {
    path: 'sms',
    name: 'SMS campaigns',
    component: SMSCampaignsMain,
    beforeEnter: smsCampaignFeatureGuard,
  },
  {
    path: 'sms/create/:campaign_id?',
    name: 'SMS campaigns / Create',
    component: CreateSMSCampaign,
    beforeEnter: smsCampaignFeatureGuard,
  },
  {
    path: 'sms/edit/:campaign_id?',
    name: 'SMS campaigns / Edit',
    component: CreateSMSCampaign,
    beforeEnter: smsCampaignFeatureGuard,
  },
  {
    path: 'sms/forward/:campaign_id?',
    name: 'SMS campaigns / Forward',
    component: CreateSMSCampaign,
    beforeEnter: smsCampaignFeatureGuard,
  },
  {
    path: 'sms/create/:campaign_id?',
    name: 'SMS campaigns / Create with recipient',
    component: CreateSMSCampaign,
    beforeEnter: smsCampaignFeatureGuard,
  },
  {
    path: 'sms/setup',
    name: 'SMS campaigns / Setup',
    component: SMSCampaignsFeatureBlock,
    beforeEnter: smsCampaignBlockPageGuard,
  },
];
